import { Injectable, Signal, WritableSignal, signal } from '@angular/core';
import {
  ActivityWithCategoryAndLocationsAndReportedDetails,
  ResolvedActivity,
} from '@wilson/interfaces';
import { Subject } from 'rxjs';

export enum ActivityDrawerCloseActionType {
  DELETE = 'delete',
  DELETE_SHIFT = 'delete_shift',
  DISSOCIATE_FROM_SHIFT = 'dissociateFromShift',
  UPDATE = 'update',
}

export interface DeleteShiftAction {
  shiftId: string;
  type: ActivityDrawerCloseActionType.DELETE_SHIFT;
}

export interface DeleteAction {
  activity: ResolvedActivity;
  type: ActivityDrawerCloseActionType.DELETE;
}

export interface DissociateActivity {
  activity: ResolvedActivity;
  type: ActivityDrawerCloseActionType.DISSOCIATE_FROM_SHIFT;
}

export interface UpdateAction {
  activity: ActivityWithCategoryAndLocationsAndReportedDetails;
  type: ActivityDrawerCloseActionType.UPDATE;
}

export type CloseAction =
  | DeleteAction
  | UpdateAction
  | DissociateActivity
  | DeleteShiftAction;

@Injectable({
  providedIn: 'root',
})
export class TimelineActivityDrawerService {
  private _isVisible = signal(false);
  private _selectedActivityId: WritableSignal<string | null> = signal(null);
  private _drawerRefSubject = new Subject<undefined | CloseAction>();

  get isVisible(): Signal<boolean> {
    return this._isVisible.asReadonly();
  }

  get selectedActivityId(): Signal<string | null> {
    return this._selectedActivityId.asReadonly();
  }

  set selectedActivityId(value: string | null) {
    this._selectedActivityId.set(value);
  }

  openDrawer(activityId: string) {
    this._isVisible.set(true);
    this._selectedActivityId.set(activityId);
    return this._drawerRefSubject.asObservable();
  }

  closeDrawer(result?: CloseAction) {
    this._isVisible.set(false);
    this._selectedActivityId.set(null);
    this._drawerRefSubject.next(result);
  }

  updateActivity(result?: CloseAction) {
    this._drawerRefSubject.next(result);
  }
}
